"use client";

import CloseIcon from "@/assets/icons/modal-close.svg";
import classNames from "classnames";

interface KnowledgeBaseTagProps {
  name: string;
  onClose: () => void;
  disabled?: boolean;
}

export function KnowledgeBaseTag({
  name,
  onClose,
  disabled,
}: KnowledgeBaseTagProps) {
  return (
    <div
      className={classNames(
        "inline-flex relative rounded-[6px] bg-[rgba(135,135,168,0.15)] text-xs text-white px-3 py-[6px] z-10"
      )}
    >
      <span>{name}</span>
      {!disabled && (
        <button
          onClick={onClose}
          disabled={disabled}
          className={classNames(
            "absolute -top-2 -right-2 w-4 h-4 flex items-center justify-center rounded-full backdrop-blur-xs cursor-pointer",
            "bg-[rgba(255,255,255,0.15)]"
          )}
          aria-label="Cancel"
        >
          <CloseIcon className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}
